import ApiResourceManager from '../ApiResourceManager';

/**
 * A restaurant's tables for table ordering (PROD-724). Responses are unwrapped:
 * `[{ id, uuid, name, is_active, sorting_order, link, is_migrated }]`. A name that is empty or
 * already taken answers 422 on `name`.
 */
export default class OnSiteTablesManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/on-site-tables',
    });

  /** Added at the end of the list, switched on. */
  create = (data) =>
    this.request({
      method: 'POST',
      url: '/on-site-tables',
      data,
    });

  /** `{ name }` or `{ is_active }`. The link stays the same when the table is renamed. */
  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/on-site-tables/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/on-site-tables/${id}`,
    });

  /** Answers with the reordered list. */
  reorder = (ids) =>
    this.request({
      method: 'PUT',
      url: '/on-site-tables-order',
      data: { ids },
    });
}
